import { DataBean } from "../DataBean";

export class DeliveryType extends DataBean {



    public async deleteDeliveryType(idDeliveryType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteDeliveryType_Number", [idDeliveryType]);
    }

    public async getDeliveryTypeCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDeliveryTypeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}